<template>
  <div class="m-4 booking-section mt-2 px-4 py-5 rounded">
    <label>Budget</label>
    <div class="flex">
      <vs-input
        type="number"
        v-model="budget"
        :disabled="
          isSearchingGuestByEmail ||
          disableComponent
        "
        :min="0"
      />
      <p class="my-auto ml-2">{{ booking.budgetCurrency }}</p>
    </div>
    <div class="mt-4">
      <p class="leading-none text-grey mb-2">
        <small>Requests from same section:</small>
      </p>
      <div
        class="p-2 cursor-pointer rounded"
        :style="{
          background:
            booking.id === listBooking.booking.id ? '#ededed' : 'transparent',
        }"
        v-for="listBooking in auctionRequests"
        :key="listBooking.booking.id"
        @click="openBooking(listBooking)"
      >
        <p>{{ listBooking.bookingCustomer.name }}</p>
        <p class="leading-none text-grey">
          <small
            >Pax: {{ listBooking.booking.guestCount }} - Budget:
            <b>{{
              formatPrice(
                listBooking.booking.budget / 100,
                listBooking.booking.budgetCurrency
              )
            }}</b></small
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import moment from "moment";
import _ from "lodash";

export default {
  computed: {
    ...mapGetters({
      enhancedRequests: "marcomBooking/enhancedRequests",
    }),
    auctionRequests() {
      var arrival = moment(this.booking.arrival)
        .set({ hour: 0, minute: 0, second: 0 })
        .toDate();
      var departure = moment(this.booking.arrival)
        .set({ hour: 24, minute: 0, second: 0 })
        .toDate();

      return this.enhancedRequests
        .filter(
          (r) =>
            r.booking.venueDetailsId.id === this.booking.venueDetailsId.id &&
            r.booking.venueSectionId.id === this.booking.venueSectionId.id &&
            moment(r.booking.arrival).isBetween(arrival, departure)
        )
        .sort((a, b) => b.booking.budget - a.booking.budget);
    },
    budget: {
      get() {
        return this.booking.budget / 100;
      },
      set(newValue) {
        Vue.set(this.booking, "budget", newValue * 100);
        var myBooking = this.auctionRequests.find(
          (ar) => ar.booking.id === this.booking.id
        );

        Vue.set(myBooking.booking, "budget", newValue * 100);
      },
    },
  },
  props: {
    booking: Object,
    disableComponent: Boolean
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    formatPrice(decAmount, currency) {
      var options = {};
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

      if (currency)
        _.assign(options, { style: "currency", currency: currency });
      var formatter = new Intl.NumberFormat("en-US", options);

      return formatter.format(decAmount); /* $2,500.00 */
    },
    openBooking(enhancedBooking) {
      this.$emit("select-booking", enhancedBooking);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-section {
  background: #f8f8f8;
}
</style>
